import {resources} from "../../../../../../../core/models/resource/resources";
import {ColumnPropertyLazySelect} from "../../../../../../../core/types/records-table.types";

export const productPackageResourceType = resources['product-packages'];
export const productPackageFilesResourceType = resources['product-package-files'];

export const propertyLazySelectProductPackageType: ColumnPropertyLazySelect = {
  recourseName: 'ProductPackageType',
  providerType: 'DEFAULT'
}
